import { jwtDecode } from 'jwt-decode'
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom-v5-compat'

import { useAuthStore } from '@sparkai/auth'
import { UserRoles } from '@sparkai/shared-types'

import { ShareLinkAccessState } from './ShareLinkAccessState'

const getOrigin = (port: number) =>
  globalThis.location.origin.includes('localhost') ? `http://localhost:${port}` : globalThis.location.origin

const getAdminUrl = (engagementId: string | null, taskId: string | null) => {
  const filter = `(key:tab,value:tasks),(key:taskId,value:${taskId})`
  const origin = getOrigin(3001)

  return engagementId
    ? `${origin}/admin/engagement/${engagementId}?filters=${btoa(filter)}`
    : `${origin}/admin/`
}

const getTaskOutcomeRedirectUrl = ({
  engagementId,
  role,
  taskId,
  taskReviewId,
}: {
  engagementId: string | null
  role: UserRoles
  taskId: string | null
  taskReviewId: string | null
}) => {
  if (role === 'admin') return getAdminUrl(engagementId, taskId)
  if (role === 'customer') {
    const origin = getOrigin(3004)

    return engagementId ? `${origin}/customer/engagement/${engagementId}` : `${origin}/customer/`
  }

  const origin = getOrigin(3002)

  return taskReviewId ? `${origin}/ms/task-review/${taskReviewId}` : `${origin}/ms/`
}

export const TaskOutcome = () => {
  const token = useAuthStore((state) => state.token)
  const decodedToken = safeDecodeToken(token)
  const role = decodedToken['https://spark.ai/sparkai-role'] as UserRoles

  const { search } = useLocation()
  const searchParams = new URLSearchParams(search)
  const engagementId = searchParams.get('engagement-id')
  const taskId = searchParams.get('task-id')
  const taskReviewId = searchParams.get('task-review-id')

  useEffect(() => {
    if (!role) return

    globalThis.location.href = getTaskOutcomeRedirectUrl({ engagementId, role, taskId, taskReviewId })
  }, [engagementId, role, taskId, taskReviewId])

  return <ShareLinkAccessState state='loading' />
}

const safeDecodeToken = (token?: string) => {
  try {
    return (token ? jwtDecode(token) : {}) as Record<string, string>
  } catch {
    return {}
  }
}
